// @flow
import * as React from 'react';
import { compose, withState } from 'recompose';
import Radium from 'radium';
import type { ReportState as ReportStateType } from 'types';
import { STATE_COLORS, Colors, Spacing } from 'utils/styleguide';
import { translateStateToHuman } from 'utils/text';

type Props = {
  state: ReportStateType,
  selected?: boolean,
  subtext?: string,
  onClick: (event: mixed) => void,

  // recompose
  hover: boolean,
  onHoverChange: (hover: boolean) => void,
};

class SelectableState extends React.Component<Props> {
  render() {
    const {
      state,
      selected,
      subtext,
      onClick,
      hover,
      onHoverChange,
    } = this.props;
    const backgroundColor = STATE_COLORS[state];
    const controlStyle = {
      borderStyle: 'solid',
      borderWidth: 2,
      borderColor: backgroundColor,
      backgroundColor: !!selected || hover ? backgroundColor : 'transparent',
    };
    const color = !!selected || hover ? Colors.White : backgroundColor;

    return (
      <div
        style={styles.root}
        onClick={onClick}
        onMouseEnter={() => onHoverChange(true)}
        onMouseLeave={() => onHoverChange(false)}
      >
        <div style={[styles.control, controlStyle]}>
          <div style={[styles.title, { color }]}>
            {translateStateToHuman(state)}
          </div>
        </div>
        {!!subtext && <div style={styles.subtext}>{subtext}</div>}
      </div>
    );
  }
}

const styles = {
  root: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: Spacing.Micro,
    cursor: 'pointer',
  },
  control: {
    display: 'inline-block',
    paddingTop: Spacing.Nano,
    paddingBottom: Spacing.Nano,
    paddingLeft: Spacing.Micro,
    paddingRight: Spacing.Micro,
    marginRight: Spacing.Micro,
  },
  title: {
    textTransform: 'uppercase',
    fontWeight: 'bold',
  },
  subtext: {
    fontWeight: 'bold',
  },
};

const SelectableStateContainer = compose(
  withState('hover', 'onHoverChange', false),
  Radium
)(SelectableState);

export default SelectableStateContainer;



// WEBPACK FOOTER //
// ./src/components/SelectableState/SelectableState.js